import React from "react";
import {
  WidgetCard,
  Headline,
  Text,
  SectionContent,
  WidgetCardsContainer,
} from "../../../../components";

const WidgetCardSection = () => {
  return (
    <SectionContent>
      <Headline text="Widget Card" nivel="2" styleAs="5" />
      <Text>Texto normal em cima</Text>
      <WidgetCardsContainer>
        <WidgetCard
          header={
            <Text
              textType="caption"
              bodyStrong
              text="TOTAL DE PRÊMIOS EM DINHEIRO"
            />
          }
        >
          <Text
            textType="headline"
            styleAs="4"
            reset={{ marginBottom: "0px" }}
            text="R$ 306.913,47"
          />
        </WidgetCard>

        <WidgetCard
          header={
            <Text textType="caption" bodyStrong text="TOTAL DE GANHADORES" />
          }
          backgroundLevel="07"
        >
          <Text
            textType="headline"
            styleAs="4"
            reset={{ marginBottom: "0px" }}
            text="7.540"
          />
        </WidgetCard>
      </WidgetCardsContainer>
      <Text textType="caption" text="um texto pequeno em baixo" />
    </SectionContent>
  );
};

WidgetCardSection.propTypes = {};

export default WidgetCardSection;
